function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  width: 40,
  height: 40,
  rx: 16,
  fill: "#BDCFDB"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M26.0385 22.0767H22.3463V20.846H26.0385V22.0767Z",
  fill: "#121221"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M28.5 26.9997H24.8078V25.769H28.5V26.9997Z",
  fill: "#121221"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M27.2693 24.5382H23.577V23.3075H27.2693V24.5382Z",
  fill: "#121221"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M20.5019 22.0767C20.4976 21.5575 20.3591 21.0482 20.0999 20.5982C19.8407 20.1483 19.4696 19.773 19.0226 19.5088L23.577 11.6154L22.5124 11L17.8497 19.0774C17.2774 18.9496 16.6823 18.9672 16.1186 19.1288C15.555 19.2904 15.0409 19.5907 14.6233 20.0023C12.3193 22.2244 12.4978 27.4194 12.5064 27.6397C12.5128 27.7986 12.5804 27.9489 12.6951 28.059C12.8098 28.1692 12.9627 28.2306 13.1218 28.2305H22.3468C22.476 28.2305 22.6019 28.1898 22.7067 28.1143C22.8114 28.0388 22.8898 27.9322 22.9306 27.8097C22.9715 27.6872 22.9727 27.5549 22.9342 27.4316C22.8957 27.3083 22.8194 27.2003 22.7161 27.1228C20.5376 25.4884 20.5019 22.11 20.5019 22.0767ZM17.3802 20.2288C17.8727 20.2342 18.3442 20.4293 18.6965 20.7735C19.0488 21.1177 19.2549 21.5845 19.2718 22.0767C19.2718 22.1001 19.273 22.2047 19.2823 22.3653L15.6516 20.7506C15.8907 20.5534 16.1667 20.4057 16.4635 20.3161C16.7602 20.2265 17.0718 20.1968 17.3802 20.2288ZM19.5463 26.9997C19.0544 26.4989 18.7409 25.8502 18.654 25.1536H17.4232C17.4673 25.8085 17.6719 26.4426 18.0189 26.9997H16.6509C16.3979 26.2011 16.2439 25.3744 16.1925 24.5382H14.9617C15.0014 25.3719 15.1388 26.1981 15.371 26.9997H13.731C13.7501 25.8699 13.9094 23.3739 14.8405 21.7364L19.4761 23.7979C19.6988 24.9544 20.1737 26.0476 20.8669 26.9997H19.5463Z",
  fill: "#121221"
});

function SvgCleaning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCleaning);
export default __webpack_public_path__ + "static/media/Cleaning.966d91cf.svg";
export { ForwardRef as ReactComponent };